import React from 'react';
import { connect } from 'react-redux';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import { fetchFollowedEntities, SET_FOLLOWED_ENTITIES_FILTER } from 'components/Pages/Home/actions.js';
import EntityContentBlock from './EntityContentBlock.jsx';

const FollowedEntityFeed = props => {
  const { followedEntitiesList, getRecentEntities } = props;
  return (
    <div>
      <ListSync
        loadOnScroll
        fetch={clear => getRecentEntities(clear)}
        listStore={followedEntitiesList}
        actionType={SET_FOLLOWED_ENTITIES_FILTER}
      >
        <EntityContentBlock />
      </ListSync>
    </div>
  );
};

const mapStateToProps = ({ Home: { followedEntitiesList } }) => ({ followedEntitiesList });

const mapDispatchToProps = dispatch => ({
  getRecentEntities: clear => dispatch(fetchFollowedEntities(clear)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FollowedEntityFeed);
